// extracted by css-extract-rspack-plugin
export default {"button_override":"LPp9q","buttonOverride":"LPp9q","#":"c7Wk_","button_label":"kRO3k","buttonLabel":"kRO3k"};